<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="#fff"
  ><path
    stroke="#02060E"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    d="M15 15.75v4.768a2.732 2.732 0 0 1-2.733 2.732H5.733A2.731 2.731 0 0 1 3 20.518V4.983A2.733 2.733 0 0 1 5.733 2.25H7.5M3 18.75h12"
  /><path
    stroke="#02060E"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    d="M9 6.75a6 6 0 1 0 12 0 6 6 0 0 0-12 0ZM15 3.75v6M15 9.75 12.75 7.5M15 9.75l2.25-2.25"
  /></svg>
</template>
